import { computed, openBlock, createElementBlock, normalizeClass, createElementVNode, normalizeStyle, renderSlot, createTextVNode, toDisplayString, createCommentVNode } from 'vue';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { addPxUnit } from './utils/format';

var props = {
  label: propTypes.string().def(''),
  labelWidth: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(''),
  size: propTypes.string().def('small'),
  border: propTypes["boolean"]().def(false),
  required: propTypes["boolean"]().def(false),
  errorMessage: propTypes.string().def(''),
  fullBorder: propTypes["boolean"]().def(false),
  splitLine: propTypes["boolean"]().def(false),
  direction: propTypes.string().def('horizontal'),
  subTitle: propTypes.string().def('')
};

var _createComponent = createComponent('form-item'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  props: props,
  setup: function setup(props, _ref) {
    var slots = _ref.slots;
    var borderClass = computed(function () {
      if (!props.border) return '';
      return props.fullBorder ? "".concat(className, "-full-border") : "".concat(className, "-border");
    });
    var directionClass = computed(function () {
      return "".concat(className, "-").concat(props.direction);
    });
    var realWidth = computed(function () {
      return addPxUnit(props.labelWidth);
    });
    return {
      className: className,
      slots: slots,
      borderClass: borderClass,
      directionClass: directionClass,
      realWidth: realWidth
    };
  }
});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass("".concat(_ctx.className))
  }, [createElementVNode("div", {
    "class": normalizeClass(["".concat(_ctx.className, "-").concat(_ctx.size), _ctx.borderClass, _ctx.directionClass])
  }, [createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__title"))
  }, [_ctx.label || _ctx.slots.label ? (openBlock(), createElementBlock("label", {
    key: 0,
    "class": normalizeClass(["".concat(_ctx.className, "__label"), _defineProperty({}, "".concat(_ctx.className, "__label-required"), _ctx.required)]),
    style: normalizeStyle({
      width: _ctx.realWidth
    })
  }, [renderSlot(_ctx.$slots, "label", {}, function () {
    return [createTextVNode(toDisplayString(_ctx.label), 1 /* TEXT */)];
  })], 6 /* CLASS, STYLE */)) : createCommentVNode("v-if", true), _ctx.slots.right && _ctx.direction === 'vertical' ? renderSlot(_ctx.$slots, "right", {
    key: 1
  }) : createCommentVNode("v-if", true)], 2 /* CLASS */), _ctx.subTitle && _ctx.direction === 'vertical' ? (openBlock(), createElementBlock("div", {
    key: 0,
    "class": normalizeClass("".concat(_ctx.className, "__sub-title"))
  }, toDisplayString(_ctx.subTitle), 3 /* TEXT, CLASS */)) : createCommentVNode("v-if", true), _ctx.slots["default"] || _ctx.slots.right ? (openBlock(), createElementBlock("div", {
    key: 1,
    "class": normalizeClass("".concat(_ctx.className, "__content"))
  }, [createElementVNode("div", {
    "class": normalizeClass(["".concat(_ctx.className, "__content-inner"), _defineProperty({}, "".concat(_ctx.className, "__content-line"), _ctx.splitLine)])
  }, [renderSlot(_ctx.$slots, "default"), _ctx.slots.right && _ctx.direction === 'horizontal' ? renderSlot(_ctx.$slots, "right", {
    key: 0
  }) : createCommentVNode("v-if", true)], 2 /* CLASS */), _ctx.errorMessage ? (openBlock(), createElementBlock("div", {
    key: 0,
    "class": normalizeClass("".concat(_ctx.className, "__content-error"))
  }, toDisplayString(_ctx.errorMessage), 3 /* TEXT, CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */)], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/form-item/form-item.vue";

var _FormItem = script;

export { _FormItem as default };
